import { Suspense, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
// import LogoTitle from '../../assets/images/logo-s.png'
import LogoTitle from '../../assets/images/temi-logo-s.gif'
import temiLogo from '../../assets/images/logo512.png'

import Logo from './Logo'
import './index.scss'
import useWindowDimensions from '../hooks/useWindowDimensions'

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const { width } = useWindowDimensions()

  const nameArray = ['e', 'm', 'i', 't', 'o', 'p', 'e']
  const jobArray = [
    'S',
    'o',
    'f',
    't',
    'w',
    'a',
    'r',
    'e',
    ' ',
    'E',
    'n',
    'g',
    'i',
    'n',
    'e',
    'e',
    'r',
    '.',
  ]

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
  }, [])

  return (
    <>
      <div className={`container home-page ${width < 768 ? 'my-20' : ''} `}>
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m</span>
            <Suspense fallback={<Loader type="pacman" />}>
              <img
                src={LogoTitle}
                alt="JavaScript Developer Name, Web Developer Name"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null // prevents looping
                  currentTarget.src = temiLogo
                }}
              />
            </Suspense>

            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={22}
            />
          </h1>
          <h2>
            Front End Developer / JavaScript Expert / SEO Expert / Crypto Ninja
          </h2>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
        </div>
        <Logo />
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Home
